import React from "react";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import * as CONSTANTS from "../../utilities/Constants";
import InstrumentTypeViewData, {
  defaultInstrumentTypeData,
} from "../../models/instrumentType/InstrumentTypeViewData";

import instrumentTypeByIdStore from "../../flux/stores/instrumentType/ByIdStore";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";
import history from "../../utilities/History";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  instrumentTypeData: InstrumentTypeViewData;
}

export default class InstrumentTypeLanding extends React.Component<
  {},
  ILandingState
> {
  private _mount: boolean = false;
  private _moduleName = CONSTANTS.MODULE_INSTRUMENTTYPE;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      instrumentTypeData: defaultInstrumentTypeData,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    instrumentTypeByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({ instrumentTypeData: state.data });
      }
    });
  }

  public breadcrumpClick = (link: string): void => {
    if (link) history.push(link);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout h-100">
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.SUBMENU_INSTRUMENT_TYPE), link: null, bolder: true }
              ], "pl-3 pb-3")
            }
            <NameHeader authKey={CONSTANTS.AUTHKEY_INSTRUMENT_TYPE} data={this.state.instrumentTypeData.name} />
            <div className="summary-layout">
              {this.state.instrumentTypeData.description !== "" ? (
                <Summary>
                  <div className="page-scroll">
                    <div className="row mt-3">
                      <div className="col-md-12"  style={{ display:'flex' }}>
                        <span className="summary-label">
                          {t(CONSTANTS.LABEL_DESCRIPTION)}:
                        </span>
                        <div className="ml-2 ellipsis-single-line" style={{lineHeight:'20px'}}>
                        <span className="summary-value">
                          {this.state.instrumentTypeData.description}
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Summary>
              ) : null}
            </div>
            <div className="summary-layout mt-4">
              <AbbTableComponent
              authKey={CONSTANTS.AUTHKEY_INSTRUMENT_TYPE}
                columns={[
                  {
                    dataField: "name",
                    text: t(CONSTANTS.MODULE_PROPERTY),
                    headerStyle: (colum, colIndex) => {
                      return { width: "15%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "customId",
                    text: t(CONSTANTS.LABEL_PROPERTYID),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "unit",
                    text: t(CONSTANTS.LABEL_UNIT),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "description",
                    text: t(CONSTANTS.LABEL_DESCRIPTION),
                    headerStyle: (colum, colIndex) => {
                      return { width: "45%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "decimal",
                    text: t(CONSTANTS.LABEL_DECIMALS),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "type",
                    text: t(CONSTANTS.TYPE),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                ]}
                list={this.state.instrumentTypeData.properties}
                select={false}
                isFixedColumn={false}
                isEditable={false}
                delete={false}
                name="Properties"
                viewAllPage={true}
                isTitle={
                  <div>
                    <p className="sidebar-main-title font-weight-bold">
                      {t(CONSTANTS.LABEL_PROPERTIES)}
                    </p>
                  </div>
                }
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
